declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, GridRow, GridData, AutoGenGrid } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
    selector: 'fseditgridrow',
    templateUrl: './fseditgridrow.modal.html',
    styleUrls: ['./fseditgridrow.modal.scss']
})

export class NgbFsEditGridRowModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() GridRow: GridRow;
    @Input() TemplateName: string;
    @Input() Date: Date;
    @Input() TitleName: string;
    @Input() Mode: string;
    @Input() Title: string;
   
    constructor(public activeModal: NgbActiveModal) {


    }
    ngOnInit() {
       // alert(this.GridRow.Cells.length);
      
    }
    onSubmit() {

        this.activeModal.close(GridRow);
    }
}
